<div class="modal-container">
  <div class="modal-header d-flex justify-content-between align-items-center">
    <h2 mat-dialog-title>Certificados de afiliación y retefuente</h2>
    <button type="button" (click)="cerrar()" class="close-btn" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content [formGroup]="formCertificado">

    <div class="modal-body">

      <div *ngIf="paso === PasoCertificado.Tipo">
        <p class="instruccion">Seleccione el tipo de certificado que desea generar</p>
        <mat-radio-group formControlName="tipoCertificado" class="d-flex justify-content-center gap-4" (change)="onTipoCertificadoChange($event.value)">
          <mat-radio-button value="Afiliación"> Afiliación </mat-radio-button>
          <mat-radio-button value="Retefuente" [disabled]="!puedeGenerarRetefuente"> Retefuente </mat-radio-button>
        </mat-radio-group>
      </div>

      <div *ngIf="paso === PasoCertificado.AfiliacionUsuarios">
        <p class="instruccion">Seleccione el o los usuario(s) al que quiere generar el certificado de afiliación.</p>
        <div class="user-list">
          <mat-checkbox [checked]="todosSeleccionados" [indeterminate]="indeterminate"
            (change)="seleccionarTodos($event)">Todos los usuarios</mat-checkbox>
          <hr>
          <div *ngFor="let user of usuarios" class="ml-3">
            <mat-checkbox [checked]="isUsuarioSelected(user)" (change)="onCheckboxChange($event, user)">
              {{ user.nombre }}
            </mat-checkbox>
          </div>
        </div>
      </div>

      <div *ngIf="paso === PasoCertificado.RetefuenteAnio">
        <p class="instruccion">Seleccione el año para generar el certificado de retención en la fuente</p>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Año</mat-label>
          <mat-select formControlName="year">
            <mat-option *ngFor="let y of listaAnios" [value]="y.value">
              {{ y.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="paso === PasoCertificado.MedioEnvio" class="text-center">
        <p class="instruccion">
          ¿Desea enviar el certificado de <b>{{ formCertificado.value.tipoCertificado }}</b> del año
          <b>{{formCertificado.value.year}}</b> de <b>{{ esRetefuente() ? (titular?.nombre || 'Titular') :
            nombresSeleccionados }}</b>?
        </p>

        <div class="envio-options mt-4 text-left">
          <mat-radio-group formControlName="medioEnvio">
            <div class="option-row">
              <mat-radio-button value="correo">Enviar por correo</mat-radio-button>
              <input type="text" formControlName="email" class="form-control mini-input" readonly>
            </div>
            <div class="option-row mt-3">
              <mat-radio-button value="whatsapp">Enviar por WhatsApp</mat-radio-button>
              <input type="text" formControlName="whatsapp" class="form-control mini-input" readonly>
            </div>
          </mat-radio-group>
        </div>
      </div>

      <div *ngIf="paso === PasoCertificado.Confirmacion" class="text-center py-4">
        <div *ngIf="paso === PasoCertificado.Confirmacion" class="text-center py-4">
          <p *ngIf="esAfiliacion()">
            Se ha enviado el certificado de {{ tipoCertificado }} de <b>{{ nombresSeleccionados }}</b>
            al
            <b>
              {{ formCertificado.get('medioEnvio')?.value === 'correo'
              ? formCertificado.get('email')?.value
              : formCertificado.get('whatsapp')?.value }}
            </b>
          </p>

          <p *ngIf="esRetefuente()">
            Se ha enviado el certificado de {{ tipoCertificado }} al
            <b>
              {{ formCertificado.get('medioEnvio')?.value === 'correo'
              ? formCertificado.get('email')?.value
              : formCertificado.get('whatsapp')?.value }}
            </b>
          </p>
        </div>
      </div>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions align="center" class="pb-4">

    <button *ngIf="paso !== PasoCertificado.MedioEnvio && paso !== PasoCertificado.Confirmacion" mat-raised-button
      color="primary" [disabled]="
    paso === PasoCertificado.Tipo
      ? !formCertificado.get('tipoCertificado')?.value
      : paso === PasoCertificado.AfiliacionUsuarios
        ? usuariosArr.length === 0
        : paso === PasoCertificado.RetefuenteAnio
          ? !formCertificado.get('year')?.value
          : false
  " (click)="siguiente()">
      {{ loadingPdf ? 'Generando...' : 'Siguiente' }}
    </button>

    <button *ngIf="paso === PasoCertificado.MedioEnvio" mat-raised-button color="primary"
      [disabled]="!formCertificado.get('medioEnvio')?.value" 
      (click)="enviar()"
      appTrackClick
      [trackData]="trackDataEnviar">
      Enviar
    </button>

    <button *ngIf="paso === PasoCertificado.Confirmacion" mat-raised-button color="primary" (click)="cerrar()">
      Aceptar
    </button>

  </mat-dialog-actions>
</div>